module.exports = __webpack_public_path__ + "img/show3.0c55b161.png";